import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentFactoryResolver, NgZone, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  public columns = [
    { name: "Name", prop: "displayname" },
    {name:"Tag Type",prop:"tagcategories_ids"},
    { name: "Notes", prop: "notes" },
    { name: "Admin Notes", prop: "admin_notes" },
    { name: "Actions", prop: "Actions" },
  ];

  // private
  private tempData = []; 

  imageUrl=environment.apiUrls.imageUrl;
  

  tag_id:any
  searchVal:any;
  @ViewChild('name') inputName
  user_role:any
  tag_cat_list =[]
  selected_tag_cat_id = null
  isTagCat : boolean =false

  guideline_data:any
  assignment_model={
    grade:'',
    max_grade:'',
    notes:'',
    admin_notes:'',
    teacher_id:'',
    status:'completed'
  }
  assignment_popup_name=''
  assignment_id:any
  public assignmentView: boolean[] = [];

  constructor( public apiService:ApiService,
               public toastr: ToastrService,
               private spinner: NgxSpinnerService,private modalService: NgbModal,
               private cdr: ChangeDetectorRef
              ) { 
                this.user_role=JSON.parse(localStorage.getItem('user'))
              }

  ngOnInit(): void {
    if(this.user_role.roles ==='admin'){
      this.getAllAssignment()
    }
    if(this.user_role.roles ==='employee'){
      this.getAllAssignmentByTeacher(this.user_role.EmpId)
    }
  }
  getAllAssignmentByTeacher(id){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAssignmentByTeacher(id).subscribe((res:any)=>{
      this.spinner.hide();
      this.rows = res?.data?.items
    })
  }
  getAllAssignment(){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAllAssignment(this.page.pageNumber +1 ,this.limitRef).subscribe((res:any)=>{
      this.spinner.hide();
      this.rows = res?.data?.items
      this.page.totalPages = res?.data?.totalCount
    })
  }
  filter(data){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.filterAssignment(data).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.spinner.hide();
        this.rows = res?.data
        this.page.totalPages = res?.data?.length
      }
    })
  }
  resetFilter(){
    this.inputName.nativeElement.value=''
    this.getAllAssignmentByTeacher(this.user_role.emp_id)
  }

  pageChangeData(page:any){
    // this.apiService.getAssignmentByTeacher(page.offset +1,page.pageSize).subscribe((res:any)=>{
    //   this.rows = res?.data?.items
    //   this.page.totalPages = res?.data?.totalCount
    // })
  }
  openModalForAssignment(content,empId,userId,grade,notes_adminNotes,prop) {
    
    this.assignment_popup_name = prop
    this.assignment_model.teacher_id = empId
    this.assignment_id = userId
    if(prop === 'Grade'){
      this.assignment_model.grade = grade
    }
    if(prop === 'Max Grade'){
      this.assignment_model.max_grade = grade
    }
    if(prop === 'Notes'){
      this.assignment_model.notes = notes_adminNotes
    }
    if(prop === 'Admin Notes'){
      this.assignment_model.admin_notes = notes_adminNotes
    }
   
    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    
    const modalRef = this.modalService.open(content,options);

    modalRef.result.then((result) => {
      this.assignment_popup_name = null
      this.assignment_model.teacher_id = null
      this.assignment_id = null
      this.assignment_model.grade = null
      this.assignment_model.max_grade = null
      this.assignment_model.admin_notes = null
    }, (reason) => {
      this.assignment_popup_name = null
      this.assignment_model.teacher_id = null
      this.assignment_id = null
      this.assignment_model.grade = null
      this.assignment_model.max_grade = null
      this.assignment_model.admin_notes = null
    });
  }
  
  assignmentUpdate(){
    if(this.assignment_popup_name === 'Grade'){
      delete this.assignment_model.max_grade
      delete this.assignment_model.notes
      delete this.assignment_model.admin_notes
    }
    if(this.assignment_popup_name === 'Max Grade'){
      delete this.assignment_model.grade
      delete this.assignment_model.notes
      delete this.assignment_model.admin_notes
    }
    if(this.assignment_popup_name === 'Notes'){
      delete this.assignment_model.grade
      delete this.assignment_model.max_grade
      delete this.assignment_model.admin_notes
    }
    if(this.assignment_popup_name === 'Admin Notes'){
      delete this.assignment_model.grade
      delete this.assignment_model.notes
      delete this.assignment_model.max_grade

    }
    this.apiService.updateAssignment(this.assignment_id,this.assignment_model).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success("Assignment submit successfull!")
        this.modalService.dismissAll()
        if(this.user_role.roles ==='admin'){
          this.getAllAssignment()
        }
        if(this.user_role.roles ==='employee'){
          this.getAllAssignmentByTeacher(this.user_role.EmpId)
      }
      }
      else this.toastr.error(res?.error)
    })
  }
 
}
